/*
 * @Description: 商家助手路由配置
 */
export default [
  {
    path: '/merchant-assistant',
    name: 'merchant-assistant',
    component: () =>
      import(
        /* webpackChunkName: "merchant-assistant" */
        '@/views/merchant-assistant/index.vue'
      ),
    meta: {
      title: '商家助手',
    },
  },
  {
    path: '/redemption-record',
    name: 'redemption-record',
    component: () =>
      import(
        /* webpackChunkName: "merchant-assistant" */
        '@/views/merchant-assistant/redemption-record.vue'
      ),
    meta: {
      title: '核销记录',
    },
  },
  {
    path: '/staff-management',
    name: 'staff-management',
    component: () =>
      import(
        /* webpackChunkName: "merchant-assistant" */
        '@/views/merchant-assistant/staff-management.vue'
      ),
    meta: {
      title: '员工管理',
    },
  },
  {
    path: '/role-management',
    name: 'role-management',
    component: () =>
      import(
        /* webpackChunkName: "merchant-assistant" */
        '@/views/merchant-assistant/role-management.vue'
      ),
    meta: {
      title: '角色管理',
    },
  },
  {
    path: '/merchant-redemption',
    name: 'merchant-redemption',
    component: () =>
      import(
        /* webpackChunkName: "merchant-assistant" */
        '@/views/merchant-assistant/merchant-redemption.vue'
      ),
    meta: {
      title: '核销',
    },
  },
    {
    path: '/my-information',
    name: 'my-information',
    component: () =>
      import(
        /* webpackChunkName: "merchant-assistant" */
        '@/views/merchant-assistant/my-info.vue'
      ),
    meta: {
      title: '我的信息',
    },
  },
]
